import { useState, useEffect } from "react";

const HISTORY_URL = "https://defi-risk-api.osepper.workers.dev/history";
const POLL_INTERVAL = 300_000; // 5 minutes

export interface HistoryPoint {
  t: string;
  positions: number;
  avg_hf: number;
  near_liq: number;
  val_at_risk: number;
  supplied: number;
  borrowed: number;
  lst_depeg_car?: number;
  lst_depeg_short?: number;
  lst_depeg_avail?: number;
  ethena_depeg_car?: number;
  ethena_depeg_short?: number;
  ethena_depeg_avail?: number;
  eth_crash_car?: number;
  eth_crash_short?: number;
  eth_crash_avail?: number;
  btc_crash_car?: number;
  btc_crash_short?: number;
  btc_crash_avail?: number;
  broad_crash_car?: number;
  broad_crash_short?: number;
  broad_crash_avail?: number;
}

export function useHistoryData() {
  const [history, setHistory] = useState<HistoryPoint[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchHistory() {
      try {
        const resp = await fetch(HISTORY_URL);
        if (resp.ok) {
          const data = await resp.json();
          if (mounted) setHistory(data);
        }
      } catch {
        // silent
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchHistory();
    const interval = setInterval(fetchHistory, POLL_INTERVAL);
    return () => { mounted = false; clearInterval(interval); };
  }, []);

  return { history, loading };
}
